import { openCookieSettings } from '../common/CookieBanner.js'
import { homeHtml } from './homeContent.js'
export function Home() {
  const el = document.createElement('div')
  el.innerHTML = homeHtml
  el.querySelector('[data-home-cookies]').onclick = openCookieSettings
  return el.firstElementChild
}
